import styled from 'styled-components';
import { Button } from '@sainsburys-tech/bolt';
var SearchContainer = styled.div.withConfig({
  displayName: "Searchstyles__SearchContainer",
  componentId: "sc-1yffgsj-0"
})(["margin:15px;margin-bottom:15px;"]);
var SearchWrapper = styled.form.withConfig({
  displayName: "Searchstyles__SearchWrapper",
  componentId: "sc-1yffgsj-1"
})(["width:100%;display:flex;flex-wrap:nowrap;align-items:center;@media (min-width:", "){width:400px;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
var LocationButton = styled(Button).withConfig({
  displayName: "Searchstyles__LocationButton",
  componentId: "sc-1yffgsj-2"
})(["margin-left:5px;border-color:", ";height:46px;width:46px;padding:0;color:", ";svg{height:20px;width:20px;}"], function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.color.monochrome.base;
});
export { SearchContainer, SearchWrapper, LocationButton };